module.exports = __webpack_public_path__ + "x4.png";